<template>
  <basic-container>
    <avue-crud
      v-if="reWrite"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      :before-close="beforeClosed"
      :onclose="onClosed"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.parkpassage_delete"
          @click="handleDelete"
        >删 除
        </el-button>

      </template>

      <template slot="menu" slot-scope="scope">
        <el-button type="text" size="small" v-show="scope.row.billingStatus==1"
                   @click="tip(scope.row)">
          <span class="el-icon-download"></span>临停付款码
        </el-button>
        <el-button type="text" size="small"
                   @click="noPlateCarQrcode(scope.row)">
          <span class="el-icon-download"></span>无牌车扫码
        </el-button>
        <el-button type="text" size="small" v-if="permissionList.openBtn"
                   @click="showPictureForm(scope.row)">
          <span class="el-icon-view"></span>远程开闸
        </el-button>
      </template>
    </avue-crud>
    <el-dialog
      title="远程开闸"
      :visible.sync="showPictureDialog"
      :modal-append-to-body="false"
      width="460px"
      @closed="handleClose"
    >
      <el-form ref="remoteOperateForm" :model="remoteOperateForm" style = "height: 340px">
        <div class="block">
          <el-col span="24">
            <el-image
              :src="remoteOperateForm.grepImage"
              style="width: 420px;height:280px;"
            >
              <div slot="error" class="image-slot">
                <div style="padding-top:140px;padding-left:100px;">{{remoteOperateForm.imageTipMessage}}</div>
              </div>
            </el-image>
          </el-col>
          <el-col span="18" offset="3" style="padding-top:15px;">
            <el-button type="primary" size="small"  v-if="permissionList.openBtn" @click="gateOperate(1)">
              <span class="el-icon-check"></span>远程开闸
            </el-button>
            <el-button type="plain" size="small"  v-if="permissionList.closeBtn" @click="gateOperate(0)">
              <span class="el-icon-close"></span>远程关闸
            </el-button>
            <el-button type="info" size="small" @click="gateOperate(2)">
              <span class="el-icon-zoom-in"></span>图片查看
            </el-button>
          </el-col>
        </div>
      </el-form>
    </el-dialog>
  </basic-container>
</template>

<script>
  import {
    add,
    getDetail,
    getList,
    beforeDelete,
    remove,
    update,
    openOrClose,
    grepImage,
  } from '@/api/v4ward/park/passage/parkpassage';
  import { loadRegionByParentId, getSpaceTree } from '@/api/v4ward/car/carparkspace';
  import { getPassRuleSelection } from '@/api/v4ward/park/pass/parkpassrule';
  import { nodeTreeByParentId } from '@/api/v4ward/car/carmonth';
  import { mapGetters } from 'vuex';
  import qrcode from 'qrcodejs2';

  export default {
    data() {
      return {
        form: {
          regionId: 0,
        },
        query: {},
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0,
        },
        reWrite: false,
        selectionList: [],
        spaceList: [],
        passRuleData: [],
        tempParkingLotId: '',
        firstDisplayFlag: false,
        operateType: '',
        option: {
          height: 'auto',
          //calcHeight: 30,
          tip: false,
          searchShow: true,
          searchMenuSpan: 4,
          border: true,
          index: true,
          viewBtn: true,
          tipBtn:true,
          selection: false,
          dialogClickModal: false,
          span: 12,
          align: 'center',
          indexLabel: '序号',
          dialogWidth: '40%',
          labelWidth: 120,
          columnBtn: false,
          refreshBtn: false,
          menuWidth: 270,
          column: [
            {
              label: '车场名称',
              prop: 'parkingLotId',
              type: 'tree',
              editDisabled: true,
              search: true,
              searchSpan: 5,
              cascaderItem: ['regionId'],
              cascaderChange: true,
              props: {
                label: 'title',
                value: 'id',
                disabled: 'disabled',
              },
              rules: [
                {
                  required: true,
                  message: '请选择车场',
                  trigger: 'change',
                },
              ],
              change: ({ value, column }) => {
                if (this.vdui.isNotEmpty(this.form.passageType) && this.vdui.isNotEmpty(value)) {
                  // 加载通行规则
                  this.loadPassRuleSelection(value, this.form.passageType);
                }
              },
            },
            {
              label: '所属区域',
              prop: 'regionId',
              type: 'tree',
              dicData: [],
              //row: true,
              dataType: 'string',
              cascaderIndex: 0,
              dicUrl: '/api/v4ward/car/parkSpaceNode/nodeTreeByParentId?parentId={{key}}',
              //dicUrl: '/api/v4ward/car/parkSpaceNode/nodeTreeByParentId?spaceId={{key}}',
              props: {
                label: 'title',
                value: 'id',
                disabled: 'disabled',
              },
              rules: [
                {
                  required: true,
                  message: '请选择区域',
                  trigger: 'change',
                },
              ],
            },
            {
              label: '通道名称',
              prop: 'passageName',
              maxlength: 10,
              rules: [
                {
                  required: true,
                  message: '请输入通道名称',
                  trigger: 'change',
                },
              ],
            },
            {
              label: '通道编号',
              prop: 'passageCode',
              maxlength: 32,
              search: true,
              searchSpan: 5,
              rules: [
                {
                  required: true,
                  message: '请输入通道编号',
                  trigger: 'change',
                },
                { pattern: /^[\u4E00-\u9FA5A-Za-z0-9_]+$/, message: '格式错误',trigger: 'blur'},
              ],
            },
            {
              label: '通道类型',
              prop: 'passageType',
              type: 'select',
              search: true,
              //editDisabled: true,
              searchSpan: 5,
              rules: [
                {
                  required: true,
                  message: '请选择通道类型',
                  trigger: 'blur',
                },
              ],
              dicData: [
                { label: '入口', value: 1 },
                { label: '出口', value: 2 },
                //{ label: '进出一体', value: 3 },
              ],
              props: {
                label: 'label',
                value: 'value',
              },
              change: ({ value, column }) => {
                if (this.operateType == '') {
                  return;
                }
                if (this.vdui.isEmpty(this.form.parkingLotId) && this.vdui.isNotEmpty(value)) {
                  this.$message.warning('请先选择停车场');
                }
                if (this.vdui.isNotEmpty(this.form.parkingLotId) && this.vdui.isNotEmpty(value)) {
                  // 加载通行规则
                  this.loadPassRuleSelection(this.form.parkingLotId, value);
                }
              },
            },
            {
              label: '值守情况',
              prop: 'onDutyPerson',
              type: 'select',
              search: true,
              searchSpan: 5,
              rules: [
                {
                  required: true,
                  message: '请选择是否有人值守',
                  trigger: 'change',
                },
              ],
              value: 1,
              dicData: [
                { label: '有人值守', value: 1 },
                { label: '无人值守', value: 0 },
              ],
              props: {
                label: 'label',
                value: 'value',
              },
            },
            {
              label: '是否计费',
              prop: 'billingStatus',
              type: 'select',
              search: true,
              searchSpan: 5,
              rules: [
                {
                  required: true,
                  message: '请选择是否是计费通道',
                  trigger: 'change',
                },
              ],
              value: 1,
              dicData: [
                { label: '计费通道', value: 1 },
                { label: '非计费通道', value: 0 },
              ],
              props: {
                label: 'label',
                value: 'value',
              },
            },
            {
              label: '通行规则',
              hide: true,
              type: 'select',
              dicData: [],
              //dicUrl: '/api/park/pass/rule/selections',
              props: {
                label: 'label',
                value: 'value',
                disabled: 'disabled',
              },
              rules: [
                {
                  required: true,
                  message: '请选择通行规则',
                  trigger: 'change',
                },
              ],
              prop: 'passRuleId',
            },
            {
              label: '备注信息',
              prop: 'remark',
              span: 24,
              type: 'textarea',
              minRows: 2,
              maxlength: 100,
              showWordLimit: true,
              overHidden: true,
            },
          ],
        },
        data: [],
        operateRow: null,
        showPictureDialog: false,
        remoteOperateForm: {
          grepping: false,
          imageTipMessage: '请点击下面图片查看抓取远程图片',
          grepImage: '',
        },
      };
    },

    computed: {
      ...mapGetters(['permission']),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.parkpassage_add, false),
          viewBtn: this.vaildData(this.permission.parkpassage_view, false),
          delBtn: this.vaildData(this.permission.parkpassage_delete, false),
          editBtn: this.vaildData(this.permission.parkpassage_edit, false),
          openBtn: this.vaildData(this.permission.parkpassage_open, false),
          closeBtn: this.vaildData(this.permission.parkpassage_close, false),
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach((ele) => {
          ids.push(ele.id);
        });
        return ids.join(',');
      },
    },
    watch: {
      'form.parkingLotId'() {
        this.form.passRuleId = '';
        //let passageTypeTem = this.form.passageType;
        /*const column = this.findObject(this.option.column, 'passageType');
        if (this.vdui.isNotEmpty(column)) {
          this.loadPassRuleSelection(this.form.passageType);
        }*/
        // if (this.operateType === 'edit') {
        //   this.loadRegion(this.form.parkingLotId);
        // }
      },
    },
    mounted() {
      //this.loadRegion();
    },
    created() {
      getSpaceTree().then((data) => {
        this.spaceList = data.data;
        if (this.spaceList.length > 0) {
          var spaceColumn = this.findObject(this.option.column, 'parkingLotId');
          spaceColumn.dicData = data.data;
          spaceColumn.searchValue = this.spaceList[0].id;
          this.query.parkingLotId = this.spaceList[0].id;
          this.tempParkingLotId = this.spaceList[0].id;
          this.$nextTick(() => {
            this.reWrite = true;
          });
        } else {
          this.$nextTick(() => {
            this.reWrite = true;
          });
        }
        this.onLoad();
      });
    },
    methods: {
      handleClose() {
        console.log("关闭。。。");
        this.showPictureDialog = false;
        this.operateRow = null;
        this.remoteOperateForm = {
            grepping: false,
            imageTipMessage: '请点击下面图片查看抓取远程图片',
            grepImage: '',
        };
      },
      showPictureForm(row){
        this.operateRow = row;
        this.showPictureDialog = true;
      },
      loadPassRuleSelection(parkingLotId, passageType) {
        if (typeof passageType === 'undefined') {
          return;
        }
        let passRuleIdColumn = this.findObject(this.option.column, 'passRuleId');
        getPassRuleSelection({
          parkId: parkingLotId,
          passageType: passageType,
        }).then((res) => {
          if (this.operateType === 'add') {
            this.form.passRuleId = null;
          }
          passRuleIdColumn.dicData = res.data;
        });
      },

      //获取区域节点数据
      loadRegion(parkId) {
        this.form.regionId = '';
        //const regionsColumn = this.findObject(this.option.column, 'regionId');
        //用于新增月卡车页面区域数据
        nodeTreeByParentId(parkId).then((res) => {
          const column = this.findObject(this.addCarmonthOption.column, 'regions');
          column.dicData = res.data;
          if (this.vdui.isEmpty(this.form.regionId) && this.vdui.isNotEmpty(column.dicData)) {
            this.form.regionId = column.dicData[0].id;
          }
        });

/*        loadRegionByParentId(parkId).then((res) => {
          if (this.operateType === 'add') {
            this.form.regionId = null;
          }
          regionsColumn.dicData = res.data;
        });*/
      },
      rowSave(row, done, loading) {
        add(row).then(
          () => {
            this.onLoad();
            this.$message.success('操作成功!');
            done();
          },
          (error) => {
            window.console.log(error);
            loading();
          },
        );
      },
      rowUpdate(row, index, done, loading) {
        update(row).then(
          () => {
            this.onLoad();
            this.$message.success('操作成功!');
            done();
          },
          (error) => {
            window.console.log(error);
            loading();
          },
        );
      },
      rowDel(row) {
        beforeDelete({ id: row.id }).then((res) => {
          if (res.data) {
            this.$alert('检测到通道有关联数据，请先删除关联信息！', {
              confirmButtonText: '确定',
              type: 'warning',
            });
          } else {
            this.$confirm('确定将选择数据删除?', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            })
              .then(() => {
                return remove({ id: row.id });
              })
              .then(() => {
                this.onLoad();
                this.$message.success('操作成功!');
              });
          }
        });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning('请选择至少一条数据');
          return;
        }
        this.$confirm('确定将选择数据删除?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            return remove({ ids: this.ids });
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      beforeOpen(done, type) {
        if (['edit', 'view'].includes(type)) {
          getDetail({ id: this.form.id }).then(({ data }) => {
            this.form = data;
            console.log(data)
            //this.form.regionId=this.form.title;
          });
          setTimeout(() => {
            console.log(this.form)
            loadRegionByParentId(this.form.parkingLotId).then((res) => {
              if (this.operateType === 'add') {
                this.form.regionId = null;
              }
              const column1 = this.findObject(this.option.column, 'regionId');
              column1.dicData = res.data;

              column1.dicData.forEach((e) => {
                if (e.id == this.form.regionId) {

                  document
                    .querySelector('div[id*=el-collapse-content] > div > div > div:nth-child(2) > div > div > div > div.el-input.el-input--small.el-input--suffix > input[placeholder="请选择 计量单位"]')
                    .value = e.title;
                }

              });
            });

          })
        }
        if (['add'].includes(type)) {
          if (['add'].includes(type)) {
            const column = this.findObject(this.option.column, 'passRuleId');
            column.dicData = [];
          }
        }
        this.operateType = type;
        done();
      },
      beforeClosed(done, type) {
        this.operateType = '';
        done();
      },
      searchReset() {
        this.query = {};
        //每次刷新页面时，开启车场搜索框默然显示第一个节点的名称
        this.firstDisplayFlag = true;
        this.query.parkingLotId = this.tempParkingLotId;
        this.onLoad();
      },
      searchChange(params, done) {
        this.query = params;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      onLoad(page) {
        page = page || this.page;
        this.loading = true;
        getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
          ({ data }) => {
            this.page.total = data.total;
            this.data = data.records;
            this.loading = false;
            this.selectionClear();
            if (this.firstDisplayFlag) {
              let ent = document.querySelector('input[placeholder="车场名称"]');
              ent.value = this.spaceList[0].title;
              this.query.parkingLotId = this.spaceList[0].id;
              //关闭默然显示，重刷页面时才开启默认显示
              this.firstDisplayFlag = false;
            }
          },
        );
      },
      grepParkImage(type) {
        //图片抓取
        grepImage({ id: this.operateRow.id, type: type }).then((res) => {
          var data = res.data;
          this.remoteOperateForm.grepping = false;
          if(data.code === 200){
            this.remoteOperateForm.grepImage = data.data;
          }else{
            this.remoteOperateForm.imageTipMessage = data.errorMessage;
          }
        });
      },
      gateOperate(type){
        if(type === 2){
          console.log("图片抓取。。");
          if(this.remoteOperateForm.grepping ){
            this.remoteOperateForm.imageTipMessage = '图片正在抓取中，请勿重复点击。。';
          }else{
            this.remoteOperateForm.imageTipMessage = '图片抓取中，请稍等。。。';
            this.remoteOperateForm.grepping = true;
            this.grepParkImage(type);
          }
        }else{
          openOrClose({ id: this.operateRow.id, type: type }).then(() => {
            this.$message.success('操作成功!');
          });
        }

      },
      //下载二维码图片
      tip(row) {
        var url = `${location.origin}/h5/carcharge/#/?outCarGateId=${row.parkingLotId}_${row.id}`;
        var qrcodeName = row.passageName + '的收款码';
        this.createQrcode(url,qrcodeName);
      },
      //无牌车出入扫码
      noPlateCarQrcode(row){
        var url = `${location.origin}/h5/carcharge/#/out-yard?passageId=${row.id}`;
        if(row.passageType === 1){
          url = `${location.origin}/h5/carcharge/#/in-yard?passageId=${row.id}`;
        }
        var qrcodeName = row.passageName + '无牌车扫码';

        this.createQrcode(url,qrcodeName);
      },
      //生成二维码
      createQrcode(codeLink,imageName){
        var div = document.createElement('div');
        const url = codeLink.replace(
          /\/api/,
          '',
        );
        console.log('url==>', url);
        const fileName = imageName;
        var code = new qrcode(div, {
          text: url,
          width: 500,
          height: 500,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: qrcode.CorrectLevel.H,
        });
        let canvas = code._el.querySelector('canvas');
        var base64Text = canvas.toDataURL('image/png');
        var blob = this.getBlob(base64Text);
        if (navigator.msSaveBlob) {
          // IE的Blob保存方法
          navigator.msSaveBlob(blob, fileName);
        } else {
          var link = document.createElement('a');
          var href = window.URL.createObjectURL(blob);
          link.href = href;
          link.download = fileName;
          document.body.appendChild(link); // firefox需要把a添加到dom才能正确执行click
          link.click();
          // 延时保证下载成功执行，否则可能下载未找到文件的问题
          setTimeout(function() {
            window.URL.revokeObjectURL(href); // 释放Url对象
            document.body.removeChild(link);
          }, 100);
        }
      },
      //下载二维码辅助方法
      getBlob(base64) {
        var mimeString = base64.split(',')[0].split(':')[1].split(';')[0]; // mime类型
        var byteString = atob(base64.split(',')[1]); //base64 解码
        var arrayBuffer = new ArrayBuffer(byteString.length); //创建缓冲数组
        var intArray = new Uint8Array(arrayBuffer); //创建视图
        for (var i = 0; i < byteString.length; i += 1) {
          intArray[i] = byteString.charCodeAt(i);
        }
        return new Blob([intArray], {
          type: mimeString,
        });
      },
    },
  };
</script>

<style>
</style>
